<template>
  <div
    class="disabled-feature"
    @click="showUpgradeModal"
  >
    <div class="disabled-feature__content">
      <VTooltip
        v-if="afterIcon"
        theme="info-tooltip"
        :placement="placement"
        :distance="distance"
        :skidding="skidding"
        :disabled="!upgradePlan"
        class="disabled-feature__tooltip"
        popperClass="disabled-feature__popper"
      >
        <icon
          v-if="upgradePlan"
          data="@icon/feature-icon.svg"
          width="var(--icon-16)"
          height="var(--icon-16)"
          class="disabled-feature__icon"
        />
        <template #popper>
          <slot name="popper">
            <div class="disabled-feature__popper__content">
              <icon
                data="@icon/feature-icon.svg"
                width="var(--icon-16)"
                height="var(--icon-16)"
                class="disabled-feature__popper__icon"
              />
              <div class="disabled-feature__popper__text">
                <BaseSubHeading
                  size="large"
                  weight="400"
                  color="monochrome-05"
                  darkColor="monochrome-04"
                  class="disabled-feature__popper__title"
                >
                  <span v-html="title" />
                </BaseSubHeading>
              </div>
              <div class="disabled-feature__popper__gap" />
            </div>
          </slot>
        </template>
      </VTooltip>
      <div
        class="disabled-feature__label"
        :class="{ 'no-access': upgradePlan }"
      >
        <slot name="label" />
      </div>
      <VTooltip
        v-if="!afterIcon"
        theme="info-tooltip"
        :placement="placement"
        :distance="distance"
        :skidding="skidding"
        :disabled="!upgradePlan"
        class="disabled-feature__tooltip"
        popperClass="disabled-feature__popper"
      >
        <icon
          v-if="upgradePlan"
          data="@icon/feature-icon.svg"
          width="var(--icon-16)"
          height="var(--icon-16)"
          class="disabled-feature__icon"
        />
        <template #popper>
          <slot name="popper">
            <div class="disabled-feature__popper__content">
              <icon
                data="@icon/feature-icon.svg"
                width="var(--icon-16)"
                height="var(--icon-16)"
                class="disabled-feature__popper__icon"
              />
              <div class="disabled-feature__popper__text">
                <BaseSubHeading
                  size="large"
                  weight="400"
                  color="monochrome-05"
                  darkColor="monochrome-04"
                  class="disabled-feature__popper__title"
                >
                  <span v-html="title" />
                </BaseSubHeading>
              </div>
              <div class="disabled-feature__popper__gap" />
            </div>
          </slot>
        </template>
      </VTooltip>
    </div>
    <slot name="after" />
  </div>
</template>

<script lang="ts" setup>
import { useAcl } from "vue-simple-acl"
import { computed } from "vue"
import { useStore } from "vuex"

import BaseSubHeading from "@/components/Base/BaseSubHeading.vue"

import { TypeOfSubscriptionFeatures } from "@/models"
import { useModal } from "@/plugins/vue-js-modal/index"
import { Actions } from "@/store"

const modal = useModal()
const store = useStore()

const props = defineProps({
  title: {
    type: String,
    default: "Feature available to <br> Business plan Users"
  },
  subTitle: {
    type: String,
    default: ""
  },
  distance: {
    type: Number,
    default: 8
  },
  skidding: {
    type: Number,
    default: 0
  },
  placement: {
    type: String,
    default: "top"
  },
  feature: {
    type: String as () => TypeOfSubscriptionFeatures | null,
    default: null
  },
  modalId: {
    type: String,
    default: "modal-business-features"
  },
  useAclField: {
    type: String,
    default: "hasSubscription"
  },
  disableRestrictions: {
    type: Boolean,
    default: false
  },
  afterIcon: {
    type: Boolean,
    default: false
  }
})

const upgradePlan = computed(() => {
  return !useAcl().can(props.useAclField) && !props.disableRestrictions
})

function showUpgradeModal() {
  if (!upgradePlan.value) return
  store.dispatch(Actions.SELECTED_SUBSCRIPTION_FEATURE, props.feature)
  modal.show(props.modalId)
}
</script>
